import { LoadingOutlined, RightOutlined } from '@ant-design/icons'
import { Empty, Pagination } from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { getVacationRequestList } from '../../api/aops.vacation.api'
import './vacationPage.scss'
const VacationRequestListTable = (props = {}) => {
  const {
    studioGroupId = null,
    setOpenDetailModal,
    setSelectedHistoryId,
    setSelectedName,
    shouldRefresh,
  } = props
  const navigate = useNavigate()
  const [vacationRequestList, setVacationRequestList] = useState([])
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize] = useState(5)
  const [paginationInfo, setPaginationInfo] = useState({
    totalElements: 0,
    totalPages: 0,
  })

  // Map leave type to Korean
  const getLeaveTypeLabel = (leaveType) => {
    const mapping = {
      DAY: '연차',
      HALF: '반차',
      QUARTER: '반반차',
    }
    return mapping[leaveType] || leaveType
  }

  // Map time slot to Korean
  const getTimeSlotLabel = (timeSlot) => {
    const mapping = {
      ALL: '종일',
      AM: '오전',
      PM: '오후',
    }
    return mapping[timeSlot] || timeSlot
  }

  const fetchVacationRequestList = async (page = 0) => {
    setLoading(true)
    try {
      const res = await getVacationRequestList({
        studioGroupId:
          studioGroupId === 0 || studioGroupId === null ? null : studioGroupId,
        page,
        size: pageSize,
        sort: 'id,DESC',
      })
      setVacationRequestList(res?.content || [])
      setPaginationInfo({
        totalElements: res?.totalElements || 0,
        totalPages: res?.totalPages || 0,
      })
    } catch (error) {
      console.error('Failed to fetch vacation request list:', error)
      setVacationRequestList([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchVacationRequestList(currentPage - 1)
  }, [currentPage, studioGroupId, shouldRefresh])

  const handlePageChange = (page) => {
    setCurrentPage(page)
  }

  return (
    <section className="vacation-box half-width">
      <div className="vacation-history-header-wrapper">
        <div className="vacation-history-header">연차 신청 리스트</div>
      </div>
      <div className="table-wrapper">
        <table className="vacation-history-table">
          <thead className="detail-list-thead">
            <tr>
              <th>이름</th>
              <th>사용일자</th>
              <th>연차 종류</th>
              <th>시간대</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td
                  colSpan={4}
                  style={{ textAlign: 'center', padding: '40px' }}
                >
                  <LoadingOutlined />
                </td>
              </tr>
            ) : vacationRequestList && vacationRequestList.length > 0 ? (
              vacationRequestList.map((item) => {
                return (
                  <tr
                    key={`${item.historyId}-${item.userId}-vacation-request`}
                    className="no-hover"
                  >
                    <td
                      style={{
                        fontSize: 16,
                        fontWeight: 700,
                        color: '#191A1C',
                      }}
                    >
                      {item.userName}
                    </td>
                    <td>{dayjs(item.targetStartDate).format('YY-MM-DD')}</td>
                    <td>{getLeaveTypeLabel(item.leaveType)}</td>
                    <td>{getTimeSlotLabel(item.timeSlot)}</td>
                    <td>
                      <button
                        className="action-button"
                        onClick={() => {
                          setOpenDetailModal(true)
                          setSelectedHistoryId(item.historyId)
                          setSelectedName(item.userName)
                        }}
                      >
                        요청보기
                        <RightOutlined className="action-button-icon" />
                      </button>
                    </td>
                  </tr>
                )
              })
            ) : (
              <tr>
                <td
                  colSpan={4}
                  style={{ textAlign: 'center', padding: '40px' }}
                >
                  <Empty description="연차 신청이 없습니다." />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {paginationInfo.totalElements > 0 && (
        <div className="pagination-wrapper">
          <Pagination
            current={currentPage}
            total={paginationInfo.totalElements}
            pageSize={pageSize}
            onChange={handlePageChange}
            showSizeChanger={false}
            showQuickJumper={false}
            showTotal={(total, range) =>
              `${range[0]}-${range[1]} / 총 ${total}개`
            }
          />
        </div>
      )}
    </section>
  )
}

export default VacationRequestListTable
